import Model from "@/models/Model"

export default class AClosePartially extends Model {
    resource() {
        return "close_partially"
    }
}